import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { Observable } from 'rxjs'
import { List } from 'immutable'
import { RuleCount } from '../rule-count.service'
import { UserSelectableResource } from '../app-resources-selector/app-resources-selector.component'
import { AppResourceRuleSelectorComponent } from '../app-resource-rule-selector/app-resource-rule-selector.component'
import { ApplicationType } from '../../services/dtos'

@Component({
  selector: 'app-resource-selection',
  templateUrl: './app-resource-selection.component.html',
  styleUrls: ['./app-resource-selection.component.scss'],
  standalone: false,
})
export class AppResourceSelectionComponent {
  @Input() formGroup: FormGroup
  @Input() possibleTagValues: Map<string, Set<string>> | null
  @Input() possibleResourceTypes: Array<{ value: string; displayName: string }> | null
  @Input() possibleResourceGroups: Array<{ value: string; displayName: string }>
  @Input() applicationType: ApplicationType
  @Input() resources: List<UserSelectableResource>
  @Input() refreshing: boolean = false
  @Input() filterText: string = ''
  @Input() rpo: number
  @Input() inclusionRulesCount$: Observable<RuleCount>
  @Input() exclusionRulesCount$: Observable<RuleCount>
  @Input() includeRulesOpen: boolean = true
  @Input() excludeRulesOpen: boolean = false
  @Input() shouldObscureExclusionRules: boolean = true
  @Input() showRescanButton: boolean = true
  @Input() readonly: boolean = false

  @Output() toggleIncludeRules = new EventEmitter<void>()
  @Output() toggleExcludeRules = new EventEmitter<void>()
  @Output() toggleExclusionRulesEnabled = new EventEmitter<void>()
  @Output() filterChange = new EventEmitter<string>()
  @Output() refreshClick = new EventEmitter<void>()
  @Output() viewIssues = new EventEmitter<void>()

  @ViewChild('inclusionTagSelector') inclusionTagSelector: AppResourceRuleSelectorComponent
  @ViewChild('exclusionTagSelector') exclusionTagSelector: AppResourceRuleSelectorComponent

  onToggleIncludeConditions(): void {
    this.toggleIncludeRules.emit()
  }

  onToggleExcludeConditions(): void {
    this.toggleExcludeRules.emit()
  }

  onToggleExclusionRules(): void {
    this.toggleExclusionRulesEnabled.emit()
  }

  onFilterChange(event: string): void {
    this.filterChange.emit(event)
  }

  onRefreshClick(): void {
    this.refreshClick.emit()
  }
}
